import {request} from "../shared/httpInterceptor";
import {useCountryLang} from "./useCountryLang";
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {IClient} from "../interfaces/IClient";

// Cache duration for context
const FIVE_MINUTES = 1000 * 60 * 5;

export const fetchContext = async (countryLang: string | null, host?: string, context?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/context`,
    method: 'get',
    host: host
  };

  // Only add context and cookies if they exist
  if (context?.req?.cookies) {
    requestConfig.cookies = context.req.cookies;
  }
  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

export const useClientContext = () => {
  const countryLang = useCountryLang()
  const queryClient = useQueryClient()
  return useQuery<IClient>(
    ["context", countryLang], 
    () => fetchContext(countryLang),
    {
      initialData: queryClient.getQueryData(["context", countryLang]),
      staleTime: FIVE_MINUTES,  // Data becomes stale after 5 minutes
      cacheTime: FIVE_MINUTES,  // Cache is removed after 5 minutes
      enabled: countryLang != null,
    }
  )
}